import UnsavedChangesBoundary, { DirtyState, useDraftDirty } from "../common/UnsavedChangesBoundary";
import React from "react";
import ModalA11yWrapper from "../../ui/ModalA11yWrapper";
import Button from "../../ui/Button";
import Textarea from "../../ui/Textarea";
import { spacing, typography } from "../../ui/tokens";

export default function ControlReviewNoteModal({
  open,
  saving = false,
  note = "",
  error = "",
  onChange,
  onCancel,
  onConfirm,
}) {
  const isDirty = useDraftDirty({ note }, open);
  if (!open) return null;

  return (
    <UnsavedChangesBoundary onClose={onCancel} itemName="control">
      {(requestClose) => (
    <ModalA11yWrapper open onClose={saving ? undefined : requestClose}>
      <div style={modalStyle}>
        <DirtyState isDirty={isDirty} />
        <div style={{ display: "grid", gap: spacing.xs / 2 }}>
          <h3 style={{ margin: 0, fontWeight: typography.weight.bold, fontSize: typography.size.lg }}>
            Review Note
          </h3>
          <div style={{ color: "#64748b", fontSize: typography.size.xs }}>
            Review-related changes require a summary note before the control is saved.
          </div>
        </div>

        <Textarea
          label="Review note"
          value={note}
          onChange={(event) => onChange?.(event.target.value)}
          disabled={saving}
          rows={8}
        />

        {error ? <div style={{ color: "#b91c1c", fontSize: typography.size.xs }}>{error}</div> : null}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: spacing.sm }}>
          <Button type="button" variant="secondary" onClick={requestClose} disabled={saving}>
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={onConfirm} disabled={saving}>
            {saving ? "Saving..." : "Save Review Note"}
          </Button>
        </div>
      </div>
    </ModalA11yWrapper>
      )}
    </UnsavedChangesBoundary>
  );
}

const modalStyle = {
  background: "white",
  borderRadius: 12,
  padding: spacing.lg,
  width: 560,
  maxWidth: "92vw",
  display: "grid",
  gap: spacing.md,
};
